<template>
  <div id="contenedor-obrassolicitudes-opciones-tool-bar">
    <v-tabs>
      <template
        v-for="(opcion, index) in opciones">
        <v-tab
          :key="index"
          :to="{ name: opcion.ruta }"
          exact>
          {{ opcion.nombre }}
        </v-tab>
      </template>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'ObrasSolicitudesOpcinesToolBar',
  data() {
    return {
      opciones: [
        {
          nombre: 'Firmas',
          ruta: 'obrasSolicitudesConfiguracionFirmas',
          icono: '',
        },
        {
          nombre: 'Plantillas',
          ruta: 'obrasSolicitudesConfiguracionPlantillas',
          icono: '',
        },
        {
          nombre: 'Etiquetas',
          ruta: 'obrasSolicitudesConfiguracionEtiquetas',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
